export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_10.2c0dc5d4.png";